<a class="skip-link" href="#main-content" (click)="skipToMainContent($event)">Skip to main content</a>

<button type="button" class="nav-hamburger" [class.nav-hamburger--open]="menuOpen"
  (click)="toggleMenu()" [attr.aria-expanded]="menuOpen" aria-controls="main-navigation"
  [attr.aria-label]="menuOpen ? 'Close navigation menu' : 'Open navigation menu'">
  <span class="nav-hamburger__bar"></span>
  <span class="nav-hamburger__bar"></span>
  <span class="nav-hamburger__bar"></span>
</button>
<div class="nav-backdrop" *ngIf="menuOpen" (click)="closeMenu()" aria-hidden="true"></div>

<kendo-gridlayout class="grid-layout-container" [gap]="{ rows: 0, cols: 0 }"
  [rows]="[{ height: 72 }, 'auto', { height: 42 }]" [cols]="[{ width: 114 }, 'auto']">
  <kendo-gridlayout-item [row]="1" [col]="1" [rowSpan]="3" id="main-navigation" class="nav-cell"
    [class.nav-cell--open]="menuOpen">
    <app-navigation (click)="closeMenu()"></app-navigation>
  </kendo-gridlayout-item>
  <kendo-gridlayout-item [row]="1" [col]="2" class="header-cell">
    <app-header></app-header>
  </kendo-gridlayout-item>
  <kendo-gridlayout-item [row]="2" [col]="2">
    <app-loader [hidden]="loading$ | async"></app-loader>
      <div class="page-container">
        <main #mainContent id="main-content" class="page-content" tabindex="-1">
          <router-outlet></router-outlet>
        </main>
      </div>
  </kendo-gridlayout-item>
  <kendo-gridlayout-item [row]="3" [col]="2">
    <footer class="footer" aria-label="Site footer">
      <app-footer></app-footer>
    </footer>
  </kendo-gridlayout-item>
</kendo-gridlayout>